module.exports = __webpack_public_path__ + "static/img/20-box.39defa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20-box.png
// module id = bKDX
// module chunks = 0